import React, { useState, useRef, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { 
    Flex, VStack, Box, Heading, FormControl, FormLabel, Input, Button, ButtonGroup, Text, CircularProgress,
    InputGroup, InputRightElement, Icon, Spacer, Divider
} from '@chakra-ui/react';
import { Form, Field } from 'react-final-form';
import {
    ViewIcon, ViewOffIcon
} from '@chakra-ui/icons';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/ReactToastify.css';

import axios from 'axios';
import { useCookies } from 'react-cookie';
import validator from "validator";
import { withNamespaces } from 'react-i18next';

import { API_SUB_URL_USER, ERROR_CODES } from '../../../constants';

import Header from '../Header';
import Navbar from '../Navbar';
import _404Page from '../../../components/404Page';
import { displayConfirmAlert } from "../../utils"

function ForgotPassword({ t }) {
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmNewPassword, setShowConfirmNewPassword] = useState(false);
    const [isValidNewPassword, setIsValidNewPassword] = useState(false);
    const [notFoundResult, setNotFoundResult] = useState(false);
    const [userId, setUserId] = useState(null)  

    const handleNewPasswordVisibility = () => setShowNewPassword(!showNewPassword);
    const handleConfirmNewPasswordVisibility = () => setShowConfirmNewPassword(!showConfirmNewPassword);

    const { forgot_password_code } = useParams();
    const mounted = useRef();
    const navigate = useNavigate();

    useEffect(() => {
        if(!mounted.current) {
            checkValidForgotPasswordCode()
            mounted.current = true;
        } else {

        }
    });

    const checkValidForgotPasswordCode = async() => {
        if(forgot_password_code) {
            try
            {
                let response = await axios.get(`${process.env.REACT_APP_API_ENDPOINT_URL}/${API_SUB_URL_USER}?password_reset=${forgot_password_code}`, {
                    auth: {
                        username: process.env.REACT_APP_BASIC_AUTH_USERNAME,
                        password: process.env.REACT_APP_BASIC_AUTH_PASSWORD
                    }
                });

                if(!response.data || response.data && response.data.length === 0) {
                    setNotFoundResult(true);
                } else {
                    setUserId(response.data[0]?.id)
                }
            }
            catch(error) {
                if(error?.code) {
                    toast.error(`${ERROR_CODES[error?.code]} (${error?.code})`, {
                        position: "bottom-right"
                    });
                }
            }
        } else {
            setNotFoundResult(true);
        }
    }

    const validate = (values) => {
        const errors = {};

        if(!values.newPassword) {
            errors.newPassword = "Required";
        }
        if(!values.confirmNewPassword) {
            errors.confirmNewPassword = "Required";
        }

        if(values.newPassword !== values.confirmNewPassword) {
            errors.newPasswordDifferentConfirmNewPassword = "Required";
        }

        if(values.newPassword) {
            const isStrongPassword = validator.isStrongPassword(values.newPassword, {minLength: 8, minLowercase: 1, minUppercase: 1, minSymbols: 0, minNumbers: 1})
            setIsValidNewPassword(isStrongPassword);
            if(!isStrongPassword) {
                errors.strongPassword = "Required";
            }
        }

        return errors;
    }

    const onSubmit = async(values, form) => {
        try
        {
            const updatePasswordRes = await axios.patch(`${process.env.REACT_APP_API_ENDPOINT_URL}${API_SUB_URL_USER}/forgot-password/update-password/${userId}`, values, {
                auth: {
                    username: process.env.REACT_APP_BASIC_AUTH_USERNAME,
                    password: process.env.REACT_APP_BASIC_AUTH_PASSWORD
                }
            });

            if(updatePasswordRes.data) {
                const passwordResetRes = await axios.put(`${process.env.REACT_APP_API_ENDPOINT_URL}/${API_SUB_URL_USER}/${userId}`, {
                    password_reset: null
                }, {
                    auth: {
                        username: process.env.REACT_APP_BASIC_AUTH_USERNAME,
                        password: process.env.REACT_APP_BASIC_AUTH_PASSWORD
                    }
                });

                if(passwordResetRes.data?.status === 200) {
                    displayConfirmAlert("Bạn đã cập nhật mật khẩu thành công", () => navigate("/login"))
                } else {
                    toast.error("Bạn đã cập nhật mật khẩu không thành công!", {
                        position: "bottom-right"
                    });
                }
            } else {
                toast.error("Bạn đã cập nhật mật khẩu không thành công!", {
                    position: "bottom-right"
                });
            }
        }
        catch(error) {
            if(error?.code) {
                toast.error(`${ERROR_CODES[error?.code]} (${error?.code})`, {
                    position: "bottom-right"
                });
            }
        }
    }

    if(notFoundResult) {
        return (
            <_404Page />
        )
    }

    return (
        <Form
            onSubmit={onSubmit}
            validate={validate}
            render={({ handleSubmit, form, submitting, pristine, valid, values }) => {
                return (
                    <form onSubmit={handleSubmit}>
                        <Box>
                            <Header />
                            <Navbar />

                            <Flex justify="center">
                                <VStack borderRadius={20} boxShadow="lg" bg="white.100" width={{base: "100%", md: "50%", lg: "50%"}} px={8} py={4}>
                                    <Heading my="10px" size="lg">Thiết lập mật khẩu mới</Heading>

                                    <Divider />

                                    <Field name="newPassword">
                                        {({ input, meta }) => (
                                            <FormControl isRequired>
                                                <FormLabel>Mật khẩu mới:</FormLabel>
                                                <InputGroup>
                                                    <Input {...input} type={showNewPassword ? 'text' : 'password'} placeholder=''
                                                        onCopy={(e) => {e.preventDefault()}} onPaste={(e) => {e.preventDefault()}}
                                                    />

                                                    <InputRightElement width="3rem">
                                                        <Button h="1.5rem" size="sm" onClick={handleNewPasswordVisibility}>
                                                            {showNewPassword ? <ViewOffIcon /> : <Icon as={ViewIcon} />}
                                                        </Button>
                                                    </InputRightElement>
                                                </InputGroup>
                                                {
                                                    !isValidNewPassword &&
                                                    <FormLabel color="red">(Độ dài tối thiểu 8 ký tự bao gồm ít nhất 1 chữ in hoa, 1 chữ in thường và 1 ký tự số)</FormLabel>
                                                }
                                            </FormControl>
                                        )}
                                    </Field>

                                    <Field name="confirmNewPassword">
                                        {({ input, meta }) => (
                                            <FormControl isRequired>
                                                <FormLabel>Xác nhận mật khẩu mới:</FormLabel>
                                                <InputGroup>
                                                    <Input {...input} type={showConfirmNewPassword ? 'text' : 'password'} 
                                                        placeholder='' onCopy={(e) => {e.preventDefault()}} onPaste={(e) => {e.preventDefault()}}/>

                                                    <InputRightElement width="3rem">
                                                        <Button h="1.5rem" size="sm" onClick={handleConfirmNewPasswordVisibility}>
                                                            {showConfirmNewPassword ? <ViewOffIcon /> : <Icon as={ViewIcon} />}
                                                        </Button>
                                                    </InputRightElement>
                                                </InputGroup>
                                            </FormControl>
                                        )}
                                    </Field>

                                    <Button colorScheme='green' type='submit' size="lg" isDisabled={!valid} mt={4}>
                                        Cập nhật mật khẩu
                                    </Button>
                                </VStack>
                                <ToastContainer />
                            </Flex>
                        </Box>
                    </form>
                )
            }}
        />
    )
}

export default withNamespaces()(ForgotPassword);